export default "__VITE_ASSET__223efd25__"